export default __webpack_public_path__ + "ceb5de3f04e702747eb0bd3d8f7c816e.png";